import api from '@services/api';
import { Approver, ApproversSearchInput } from '../models/approvers';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all approvers related CRUD calls
 */
export const approversApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    approvers: builder.query<PaginationResponse<Approver>, ApproversSearchInput>({
      query: (input: ApproversSearchInput) => ({
        url: encodeURI(
          `/report/project-person/approvers/search?searchTerm=${input.searchTerm}&project=${input.project}&page=${input.page}&size=${input.size}&sortKey=name&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Approvers'],
    }),
  }),
});

export const { useApproversQuery } = approversApi;
